import * as types from './types';

const INITIAL_STATE = {
  getting_exams_requests: false,
  creating_exams_request: false,
  examsRequests: [],
  errors: []
};

function ExamsRequestsReducer(state = INITIAL_STATE, action) {
  switch (action.type) {
    case types.CREATE_REQUEST_EXAM_REQUEST:
      return {
        ...state,
        creating_exams_request: true
      };

    case types.CREATE_REQUEST_EXAM_SUCCESS:
      return {
        ...state,
        creating_exams_request: false,
      };
    case types.CREATE_REQUEST_EXAM_FAILURE:
      return {
        ...state,
        creating_exams_request: false
      };

    case types.GET_REQUEST_EXAMS_REQUEST:
      return {
        ...state,
        getting_exams_requests: true
      };

    case types.GET_REQUEST_EXAMS_SUCCESS:
      return {
        ...state,
        getting_exams_requests: false,
        examsRequests: action.payload
      };
    case types.GET_REQUEST_EXAMS_FAILURE:
      return {
        ...state,
        getting_exams_requests: false
      };

    default:
      return state;
  }
}

export default ExamsRequestsReducer;